export const Fonts = {
    Primary:'Montserrat'
    
}